import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SetLevel, SetSkill } from './career-plans.actions';
import { patch } from '@ngxs/store/operators';
import { CareerPlanLevel, CareerPlanSkill } from '../../models/career-plans';

export type CareerPlansStateModel = {
  selectedSkill?: CareerPlanSkill;
  selectedLevel?: CareerPlanLevel;
};

export const initialState: CareerPlansStateModel = {
  selectedSkill: undefined,
  selectedLevel: undefined,
};

@State<CareerPlansStateModel>({
  name: 'careerPlans',
  defaults: initialState,
})
@Injectable()
export class CareerPlansState {
  @Selector()
  static selectedSkill(state: CareerPlansStateModel) {
    return state.selectedSkill;
  }

  @Selector()
  static selectedLevel(state: CareerPlansStateModel) {
    return state.selectedLevel;
  }

  @Action(SetSkill)
  setSkill(context: StateContext<CareerPlansStateModel>, { skill }: SetSkill) {
    context.setState(
      patch({
        selectedSkill: skill,
      })
    );
  }

  @Action(SetLevel)
  setLevelIndex(context: StateContext<CareerPlansStateModel>, { level }: SetLevel) {
    context.setState(
      patch({
        selectedLevel: level,
      })
    );
  }
}
